import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { toHex } from "@smithy/util-hex-encoding";
export var Int64 = /*#__PURE__*/function () {
  function Int64(bytes) {
    _classCallCheck(this, Int64);
    this.bytes = bytes;
    if (bytes.byteLength !== 8) {
      throw new Error("Int64 buffers must be exactly 8 bytes");
    }
  }
  _createClass(Int64, [{
    key: "valueOf",
    value: function valueOf() {
      var bytes = this.bytes.slice(0);
      var negative = bytes[0] & 128;
      if (negative) {
        negate(bytes);
      }
      return parseInt(toHex(bytes), 16) * (negative ? -1 : 1);
    }
  }, {
    key: "toString",
    value: function toString() {
      return String(this.valueOf());
    }
  }], [{
    key: "fromNumber",
    value: function fromNumber(number) {
      if (number > 9223372036854776000 || number < -9223372036854776000) {
        throw new Error("".concat(number, " is too large (or, if negative, too small) to represent as an Int64"));
      }
      var bytes = new Uint8Array(8);
      for (var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256) {
        bytes[i] = remaining;
      }
      if (number < 0) {
        negate(bytes);
      }
      return new Int64(bytes);
    }
  }]);
  return Int64;
}();
function negate(bytes) {
  for (var i = 0; i < 8; i++) {
    bytes[i] ^= 0xff;
  }
  for (var _i = 7; _i > -1; _i--) {
    bytes[_i]++;
    if (bytes[_i] !== 0) break;
  }
}